import { render, staticRenderFns } from "./changeNewPhone.vue?vue&type=template&id=24881cdc&scoped=true"
import script from "./changeNewPhone.vue?vue&type=script&lang=js"
export * from "./changeNewPhone.vue?vue&type=script&lang=js"
import style0 from "./changeNewPhone.vue?vue&type=style&index=0&id=24881cdc&prod&lang=less&scoped=true"
import style1 from "./changeNewPhone.vue?vue&type=style&index=1&id=24881cdc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24881cdc",
  null
  
)

export default component.exports